import "ci5/smart_form";
import "ci5/sites/gocompare/radiobutton";

//= = Description
// This smart_form widget applies custom behaviour to GoCompare forms
//
//= = Behaviour
// - applies radio button and checkbox enhancements
// - disables standard info box show/hide on focus/hover (help tooltips
//   visibility is handled by the block highlighting mechanism instead)
// - sets custom markup for help icons
// - highlights questions on hover, focus and click (not for mobile breakpoint)
// - sets up custom group highlighting for invalid claim questions

(function ($) {
  $.widget("gocompare.smart_form", $.chopin.smart_form, {
    options: {
      helpTriggerHtml:
        "<span class='info-box-toggle help-icon'><span class='help-trigger'>Help</span></span>",
      showHelpOnFocus: false,
      showHelpOnHover: false,
      pleaseWait: "Loading...",
    },

    _create() {
      const _this = this;

      this._super();

      this.element.find(":radio").radiobutton();
      this.element.find(":checkbox").checkbox();

      this._on({
        "focusin .control-block": function (e) {
          if (this.options.breakpoint === "mobile") return;
          this._deactivateBlock();
          this._activateBlock($(e.currentTarget));
        },
        "click .control-block": function (e) {
          if (this.options.breakpoint === "mobile") return;
          this._deactivateBlock();
          this._activateBlock($(e.currentTarget));
        },
        "mouseenter .control-block,.claim": function (e) {
          if (this.options.breakpoint === "mobile") return;
          this._deactivateBlock();
          this._activateBlock($(e.currentTarget));
        },
        "mouseleave .control-block,.claim": function () {
          if (this.options.breakpoint === "mobile") return;
          this._deactivateBlock();
        },
      });

      // Close help when clicking on page
      this._on(this.document, {
        click(e) {
          if (
            this.options.breakpoint === "mobile" &&
            $(e.target).closest(".info-box-toggle").length === 0 &&
            $(e.target).closest(".info-box").hasClass(".info-box-active")
          ) {
            this.element.infoBoxSet("hide");
          }
        },
      });

      this._onEnterBreakpoint("mobile", () => {
        _this._deactivateBlock();
      });

      this.element.find(".claim.control-group").each(function () {
        const $controlGroup = $(this);
        $controlGroup.on("validationchange", () => {
          if ($controlGroup.find(":input").filter(".error").length > 0) {
            $controlGroup.addClass("error");
            $controlGroup.find(".control-block.error").removeClass("error");
          } else {
            $controlGroup.removeClass("error");
          }
        });
      });
    },

    _activateBlock(block) {
      if (block.closest(".claim").length) {
        block = block.closest(".claim");
      }

      this.activeBlock = block.addClass("active");
    },

    _deactivateBlock() {
      if (this.activeBlock) {
        this.activeBlock.removeClass("active");
        this.activeBlock = null;
      }
    },
  });
})(window.jQuery);
